import { gql } from "apollo-angular";
import { DIF } from "./disclaimer-item";
import { SIF_THANK_YOU } from "./sif-thank-you";

export const  SIF_FORM = gql`
  fragment SIF_FORM on SifGenericForm {
    bgColor {
      color
    }
    header
    hTag
    subHeader1
    subHeader2
    firstNameLabel
    firstNameErrorMsg
    lastNameLabel
    lastNameErrorMsg
    emailLabel
    emailErrorMsg
    phoneLabel
    phoneErrorMsg
    zipCodeLabel
    zipErrorMsg
    countryCodeLabel
    countryCodeErrorMsg
    countryLabel
    countryErrorMsg
    submitButton
    submitLoaderText
    introCopy
    fieldsCollection {
      items {
        fieldId
        label
        errorMsg
      }
    }
    tcpaDisclaimer {
      ... DIF
    }
    gdprDisclaimer {
      ... DIF
    }
    gdprCheckBoxNotice
    scheduleAppointment {
      ... SIF_THANK_YOU
    }
    thankYouCollection {
      items  {
        ... SIF_THANK_YOU 
      }
    }
    disclaimers {
      ... DIF
    }
    
    
  }
  ${DIF}
  ${SIF_THANK_YOU}`;
